export enum TafaceCertificaDurationEnum {
  '1 año' = '1 año',
  '2 años' = '2 años',
}
